import React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import { capitalize, Divider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth';
import { useLogout } from '../../data/useLogout';
import { theme } from '../../utils/theme';
import { StringAvatarProps, User } from '../../types/global.types';

const stringToColor = (string: string) => {
  let hash = 0;
  for (let i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  return color;
};

const stringAvatar = (user: User): StringAvatarProps => {
  let children;
  if (user.display_name) {
    const tokens = user.display_name.split(' ');
    children = tokens[0][0].toUpperCase();
    if (tokens.length > 1) {
      children = children + tokens[tokens.length - 1][0];
    }
  } else {
    children = user.email.split('@')[0][0].toUpperCase();
  }
  return {
    sx: {
      bgcolor: stringToColor(user.display_name || user.email),
    },
    children,
  };
};

export const InternalAvatarMenu: React.FC = () => {
  const logoutMutation = useLogout();
  const navigate = useNavigate();
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  if (logoutMutation.isSuccess) {
    navigate('/login', { replace: true });
  }

  const menuOpen = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleLogout = () => {
    logoutMutation.mutate();
  };

  return (
    <div style={{ display: 'flex', alignSelf: 'flex-end', cursor: 'pointer' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={handleClick}
      >
        <Avatar
          {...stringAvatar(auth.user)}
          aria-controls={menuOpen ? 'internal-avatar-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={menuOpen ? 'true' : undefined}
          style={{ marginLeft: '15px', marginBottom: '4px' }}
        />
        <div
          style={{
            marginLeft: theme.spacing(1.5),
            display: 'inline-block',
            width: '150px',
          }}
        >
          <Typography variant="body1" color="initial">
            {auth.user.display_name}
          </Typography>
          <Typography variant="caption" color="textSecondary" padding={0}>
            {auth.user.internal_role
              ?.split('-')
              .map((s: string) => capitalize(s))
              .join(' ')}
          </Typography>
        </div>
      </div>

      <Menu
        sx={{ width: '215px' }}
        id="internal-avatar-menu"
        anchorEl={anchorEl}
        open={menuOpen}
        onClose={handleClose}
        MenuListProps={{ 'aria-labelledby': 'basic-button' }}
      >
        <Divider />
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </div>
  );
};
